export default "__VITE_ASSET__BcsIiHks__"